import { getAnalytics, logEvent, setAnalyticsCollectionEnabled, setUserId } from "firebase/analytics";

import { PGSchema } from "../api/v2/schemas/pg.schema.js";

class Jobs {
	async view(pg_id: string, jid: number, currency: string, salary: number) {
		var params = {
			type: "job",
			pg_id: pg_id,
			jid: jid,
			currency: currency
		};
		logEvent(getAnalytics(), "ct_job_view", params);
		window.fbq?.("track", "ViewContent");
	}

	async app(pg_id: string, jid: PGSchema.jobs["job_id"], currency: string, salary: number, type: string) {
		var params = {
			type: type,
			pg_id: pg_id,
			jid: jid,
			currency: currency
		};
		let eventName = "ct_job_app";
		logEvent(getAnalytics(), eventName, params);
		window.fbq?.("trackCustom", eventName, params);
	}

	async search(searchString: string, country: string, state: string) {
		var params = {
			fb_content_type: "job",
			fb_search_string: searchString,
			country: country,
			state: state
		};
		logEvent(getAnalytics(), "ct_search_job", params);
	}
}
class login {
	async login(uid: string, method?: "google" | "googleyolo" | "facebook" | "microsoft" | "email" | "twitter" | "whatsapp") {
		var params = { uid: uid, method: method };
		logEvent(getAnalytics(), "ct_login", params);
		setUserId(getAnalytics(), uid);
		window.fbq?.("trackCustom", "ct_login", params);
	}
	async register(method?: "google" | "googleyolo" | "facebook" | "microsoft" | "email" | "twitter" | "whatsapp") {
		var params = { method: method };
		logEvent(getAnalytics(), "ct_auth_user", params);
		window.fbq?.("trackCustom", "ct_register", params);
	}
	async authUser(uid: string, method?: "google" | "googleyolo" | "facebook" | "microsoft" | "email" | "twitter" | "whatsapp") {
		var params = { uid: uid, method: method };
		logEvent(getAnalytics(), "ct_auth_user", params);
		setUserId(getAnalytics(), uid);
		window.fbq?.("trackCustom", "ct_auth_user", params);
	}
	async anonymousUser(uid: string) {
		var params = { uid: uid };
		logEvent(getAnalytics(), "ct_anonymous_user", params);
		window.fbq?.("trackCustom", "ct_anonymous_user", params);
	}
	async initApp() {
		fbq("init", "449763745569021");
		setAnalyticsCollectionEnabled(getAnalytics(), true);
	}
}

class router {
	async viewpage() {
		logEvent(getAnalytics(), "screen_name", {
			firebase_screen: document.title,
			firebase_screen_class: window.ctrouter?.$$("#content")?.firstElementChild?.tagName
		});
		logEvent(getAnalytics(), "page_view");
		window.fbq?.("track", "PageView");
	}
}
class notifications {
	async incommingNotification(payload: { from: string; utm_medium: string }) {
		logEvent(getAnalytics(), "ct_incomming_notification", { from: payload.from, utm_medium: payload.utm_medium || "default" });
	}
}

// Clase para los logs de landing en hirex.app 
// Vamos a tracking los eventos de CTA, contact, pricing, startNow, features, videoPlay, languageChange, timeOnPage, bounceRate
class LandingPage {
	async heroCtaClick(buttonText: string, section: string) {
		logEvent(getAnalytics(), "hirex_hero_cta_click", {
			button_text: buttonText,
			section: section,
			page: "landing"
		});
		window.fbq?.("trackCustom", "hirex_hero_cta_click", { button_text: buttonText, section: section });
	}

	async contactFormSubmit(formType: "demo" | "contact") {
		logEvent(getAnalytics(), "hirex_contact_form_submit", {
			form_type: formType,
			page: "landing"
		});
		window.fbq?.("track", "Lead", { content_name: formType });
	}

	async pricingView(plan: string) {
		logEvent(getAnalytics(), "hirex_pricing_view", {
			plan: plan,
			page: "pricing"
		});
		window.fbq?.("trackCustom", "hirex_pricing_view", { plan: plan });
	}

	async startNowClick(source: string) {
		logEvent(getAnalytics(), "hirex_start_now_click", {
			source: source,
			destination: "admin.hirex.app/start"
		});
		window.fbq?.("trackCustom", "hirex_start_now_click", { source: source });
	}

	async featureView(feature: string) {
		console.log("featureView222", feature);
		logEvent(getAnalytics(), "hirex_feature_view", {
			feature: feature
		});
		window.fbq?.("trackCustom", "hirex_feature_view", { feature: feature });
	}

	async videoPlay(videoId: string, section: string) {
		logEvent(getAnalytics(), "hirex_video_play", {
			video_id: videoId,
			section: section
		});
		window.fbq?.("trackCustom", "hirex_video_play", { video_id: videoId, section: section });
	}

	async languageChange(lang: string) {
		logEvent(getAnalytics(), "hirex_language_change", {
			language: lang
		});
		window.fbq?.("trackCustom", "hirex_language_change", { language: lang });
	}
}

// eventos para los engagement y metrics de tiempo en pagina
class Engagement {
	async timeOnPage(seconds: number, page: string) {
		logEvent(getAnalytics(), "hirex_time_on_page", {
			time_seconds: seconds,
			page: page
		});
	}

	async bounceRate(page: string) {
		logEvent(getAnalytics(), "hirex_bounce", {
			page: page
		});
	}
}

let PX = <T extends object>(t: T) =>
	new Proxy(t, {
		// Handler para la obtención de propiedades
		get(target, key, receiver) {
			if (["empleo.gt", "hirex.app"].some(s => location.origin.includes(s))) {
				return target[key as keyof T];
			}
			setAnalyticsCollectionEnabled(getAnalytics(), false);
			return function (..._args: any[]) {};
		},

		// Handler para la configuración de propiedades
		set(target, key, value) {
			target[key as keyof T] = value;
			return true;
		}
	});
class HXLogs {
	jobs = PX(new Jobs());
	login = PX(new login());
	router = PX(new router());
	notifications = PX(new notifications());
	landing = PX(new LandingPage());
	engagement = PX(new Engagement());
}
export const CTlog = new HXLogs();

export async function logSearchedJobEvent(searchString: string, country: string, state: string) {
	var params = {
		fb_content_type: "job",
		fb_search_string: searchString,
		country: country,
		state: state
	};
	logEvent(getAnalytics(), "ct_search_job", params);
}

export async function logSee_notificationsEvent() {
	logEvent(getAnalytics(), "ct_see_notifications");
}

export async function openRegister() {
	logEvent(getAnalytics(), "ct_register_start");
}
export async function finishRegister() {
	logEvent(getAnalytics(), "ct_register_finish");
	window.fbq?.("track", "CompleteRegistration");
}

export async function logPublishJobEvent(country: string, currency: string, salary: string) {
	var params = { country, currency };
	logEvent(getAnalytics(), "ct_publish_job");
}

export async function logChangeLangEvent(lang: any) {
	var params = { lang: lang };
	logEvent(getAnalytics(), "ct_change_lang");
}
